module.exports = __webpack_public_path__ + "static/media/policia.6054d7a1.png";